import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Platform } from '@ionic/angular';
import moment from 'moment';
import { Subject } from 'rxjs';
import { IBaseInputContract } from '../contracts/base-input';
import TIMEPICKERALBERTATHEME from '../date-time/date-time-picker-options';
import { DateType } from '../date-time/date-time.component';

@Component({
  selector: 'pia-time-picker',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
})
export class TimeComponent implements OnInit, OnDestroy, IBaseInputContract, ControlValueAccessor {
  @Input() public title = '';
  @Input() public placeholder = '';
  @Input() public preSelection: Date;
  @Input() public type: DateType = DateType.Date;
  @Input() public showClearButton = false;
  @Input() public required = false;
  @Input() public icon: string;
  @Input() public disabled: boolean;
  @Input() public noIcon = false;
  @Input() public description: string;
  @Input() public minTime: string | Date;
  @Input() public maxTime: string | Date;
  @Input() public noDeleteButton = false;
  @Output() public change: EventEmitter<Date> = new EventEmitter<Date>();

  @ViewChild('picker', { static: true }) public timePicker: any;
  @ViewChild('timeInput', { static: true }) public timeInputElement: any;

  public albertaTimePickerOptions = TIMEPICKERALBERTATHEME;
  public date: Date;
  private _ngUnsubscribe = new Subject();

  private onChange = (_date: Date) => { };
  private onTouched = () => { };

  constructor(public plt: Platform, public ngControl: NgControl, private _changeDetectorRef: ChangeDetectorRef) {
    ngControl.valueAccessor = this;
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._ngUnsubscribe.next(true);
    this._ngUnsubscribe.complete();
  }

  clearDate(event: Event): void {
    event.stopPropagation();
    this.date = null;
    this.change.emit(null);
  }
  cancel() {
    this.markAsTouched();
  }

  setTime(value) {
    const retVal = moment(`01.01.1970 ${value}`, 'DD.MM.YYYY HH:mm').utc().toDate();
    this.date = retVal;
    this.change.emit(this.date);
    this.updateChanges();
  }

  openTimePicker() {
    this.timeInputElement.nativeElement.click();
  }

  public markAsTouched(): void {
    this.onTouched();
  }

  public updateChanges() {
    this.onChange(this.date);
  }

  // ControlValueAccessor interface
  public writeValue(obj: any) {
    this.date = obj;
    this._changeDetectorRef.markForCheck();
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public removeInput($event): void {
    this.clearDate($event);
    this.updateChanges();
  }
}
